<template>
    <div class="container">
        <b-modal
            :model-value="showDialogEdit"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.editCompany"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog edit-company-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <!-- Campo: Nombre -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.name }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="Item.nombre" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="Nombre de la compañía"
                            @blur="validateField('name')"
                        />
                        <span class="error-message" v-if="errors?.name">{{ errors?.name }}</span>
                    </b-col>
                </b-row>

                <!-- Campo: Moneda -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.moneda }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="Item.id_moneda"
                            class="form-input"
                            @blur="validateField('id_moneda')"
                        >
                            <template #first>
                                <b-form-select-option value="" disabled>
                                    -- {{ labels.selectCurrency }} --
                                </b-form-select-option>
                            </template>
                            <option 
                                :key="currency.id" 
                                :value="currency.id" 
                                v-for="currency in listCurrency"
                            >
                                {{ currency?.nombre }}
                            </option>
                        </b-form-select>
                        <span class="error-message" v-if="errors?.id_moneda">{{ errors?.id_moneda }}</span>
                    </b-col>
                </b-row>

                <!-- Campo: Acrónimo -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.acronym }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="Item.acronym" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="Acrónimo de la compañía"
                            @blur="validateField('acronym')"
                        />
                        <span class="error-message" v-if="errors?.acronym">{{ errors?.acronym }}</span>
                    </b-col>
                </b-row>

                <!-- Campo: Código -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.code }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="Item.codigo" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="Código de la compañía"
                        />
                    </b-col>
                </b-row>

                <!-- Campo: NIT -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.nit }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="Item.identificacion" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="NIT de la compañía"
                            @blur="validateField('identificacion')"
                        />
                        <span class="error-message" v-if="errors?.identificacion">{{ errors?.identificacion }}</span>
                    </b-col>
                </b-row>

                <!-- Campo: Grupo (selección múltiple por botones) -->
                <b-row class="d-flex align-items-start uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.group }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <div class="company-group-picker">
                            <button
                                v-for="grupo in listGrupos"
                                :key="grupo.id"
                                type="button"
                                class="company-group-chip"
                                :class="{ active: isGroupSelected(grupo.id) }"
                                @click="toggleGroupSelection(grupo.id)"
                            >
                                <span class="company-group-chip-text">{{ grupo?.nombre }}</span>
                            </button>
                        </div>
                        <span class="error-message" v-if="errors?.id_grupos">{{ errors?.id_grupos }}</span>
                    </b-col>
                </b-row>

                <!-- Botones de acción -->
                <div class="reset-dialog-actions d-flex justify-content-between mt-4 uniform-actions-wrap">
                    <div class="actions-left">
                        <b-button 
                            class="reset-btn-danger" 
                            @click="confirmDelete" 
                            :disabled="isLoading"
                        >
                            <font-awesome-icon :icon="['fas', 'trash']" class="mr-1" />
                            {{ labels.delete }}
                        </b-button>
                    </div>
                    <div class="actions-right d-flex">
                        <b-button class="reset-btn-secondary" @click="clicked">{{ labels.close }}</b-button>
                        <b-button class="reset-btn-primary ml-2" @click="editCompany" :disabled="isLoading">
                            <b-spinner v-if="isLoading" small class="mr-1"></b-spinner>
                            {{ labels.save }}
                        </b-button>
                    </div>
                </div>
            </div>
        </b-modal>

        <!-- Modal Confirmación Eliminar -->
        <InacticaItem 
            :InactivaItem="showDeleteModal" 
            @confirmDelete="confirmDeleteCompany" 
            @cierraModal="closeDeleteModal"
        />
    </div>
</template>

<script>
import Company from "@/services/Company"
import Currency from "@/services/Currency"
import Grupo from "@/services/Grupo"
import InacticaItem from "../utils/InacticaItem.vue"

export default {
    name: "Edit",
    components: {
        InacticaItem
    },
    props: ['showDialogEdit', 'Item'],
    data: () => ({
        listCurrency: [],
        listGrupos: [],
        selectedGrupos: [],
        isLoading: false,
        showDeleteModal: false,
        errors: {
            name: "",
            id_moneda: "",
            acronym: "",
            identificacion: "",
            id_grupos: ""
        }
    }),
    watch: {
        showDialogEdit(val) {
            if (val && this.Item) {
                this.loadGruposAndInit()
                this.resetErrors()
            }
        },
        Item: {
            handler(newVal) {
                if (newVal && this.showDialogEdit) {
                    this.initSelectedGrupos()
                    this.resetErrors()
                }
            },
            deep: true
        }
    },
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    editCompany: "Editar Compañía",
                    name: "Nombre",
                    moneda: "Moneda",
                    selectCurrency: "Seleccione una moneda",
                    acronym: "Acrónimo",
                    code: "Código",
                    nit: "NIT",
                    group: "Grupo",
                    delete: "Eliminar",
                    save: "Guardar",
                    close: "Cerrar",
                    infoTitle: "Datos de la compañía",
                    infoText: "Actualiza la información de la compañía y guarda los cambios."
                }
            } else {
                return {
                    editCompany: "Edit Company",
                    name: "Name",
                    moneda: "Currency",
                    selectCurrency: "Select a currency",
                    acronym: "Acronym",
                    code: "Code",
                    nit: "Tax ID",
                    group: "Group",
                    delete: "Delete",
                    save: "Save",
                    close: "Close",
                    infoTitle: "Company information",
                    infoText: "Update the company information and save changes."
                }
            }
        }
    },
    methods: {
        resetErrors() {
            this.errors = {
                name: "",
                id_moneda: "",
                acronym: "",
                identificacion: "",
                id_grupos: ""
            }
        },
        validateField(field) {
            const lang = this.$store.state._language
            
            switch(field) {
                case 'name':
                    if (!this.Item.nombre) {
                        this.errors.name = lang == "es-ES" ? "El nombre es obligatorio" : "Name is required"
                    } else if (this.Item.nombre.length < 3) {
                        this.errors.name = lang == "es-ES" ? "El nombre debe tener al menos 3 caracteres" : "Name must have at least 3 characters"
                    } else {
                        this.errors.name = ""
                    }
                    break
                
                case 'id_moneda':
                    if (!this.Item.id_moneda) {
                        this.errors.id_moneda = lang == "es-ES" ? "Debe seleccionar una moneda" : "Please select a currency"
                    } else {
                        this.errors.id_moneda = ""
                    }
                    break
                
                case 'acronym':
                    if (!this.Item.acronym) {
                        this.errors.acronym = lang == "es-ES" ? "El acrónimo es obligatorio" : "Acronym is required"
                    } else if (this.Item.acronym.length < 2) {
                        this.errors.acronym = lang == "es-ES" ? "El acrónimo debe tener al menos 2 caracteres" : "Acronym must have at least 2 characters"
                    } else {
                        this.errors.acronym = ""
                    }
                    break
                
                case 'identificacion':
                    if (!this.Item.identificacion) {
                        this.errors.identificacion = lang == "es-ES" ? "El NIT es obligatorio" : "Tax ID is required"
                    } else if (!/^\d{1,20}$/.test(this.Item.identificacion)) {
                        this.errors.identificacion = lang == "es-ES" ? "El NIT solo debe contener números" : "Tax ID must contain only numbers"
                    } else {
                        this.errors.identificacion = ""
                    }
                    break
                
                case 'id_grupos':
                    if (!this.selectedGrupos || this.selectedGrupos.length === 0) {
                        this.errors.id_grupos = lang == "es-ES" ? "Debe seleccionar al menos un grupo" : "Please select at least one group"
                    } else {
                        this.errors.id_grupos = ""
                    }
                    break
            }
        },
        validateForm() {
            this.validateField('name')
            this.validateField('id_moneda')
            this.validateField('acronym')
            this.validateField('identificacion')
            this.validateField('id_grupos')
            
            return !this.errors.name && 
                   !this.errors.id_moneda && 
                   !this.errors.acronym && 
                   !this.errors.identificacion && 
                   !this.errors.id_grupos
        },
        isGroupSelected(groupId) {
            return this.selectedGrupos.includes(String(groupId))
        },
        toggleGroupSelection(groupId) {
            const id = String(groupId)
            const index = this.selectedGrupos.indexOf(id)

            if (index === -1) {
                this.selectedGrupos = [...this.selectedGrupos, id]
            } else {
                this.selectedGrupos = this.selectedGrupos.filter((selectedId) => selectedId !== id)
            }

            this.validateField('id_grupos')
        },
        initSelectedGrupos() {
            if (this.Item.id_grupos) {
                this.selectedGrupos = this.Item.id_grupos
                    .split(',')
                    .map(id => id.trim())
                    .filter(id => id !== '')
            } else {
                this.selectedGrupos = []
            }
        },
        async loadGruposAndInit() {
            if (this.listGrupos.length === 0) {
                try {
                    const res = await Grupo.getAllGrupos()
                    this.listGrupos = res.data.grupos
                    this.initSelectedGrupos()
                } catch (error) {
                    console.error("Error loading grupos:", error)
                }
            } else {
                this.initSelectedGrupos()
            }
        },
        confirmDelete() {
            this.showDeleteModal = true
        },
        closeDeleteModal() {
            this.showDeleteModal = false
        },
        confirmDeleteCompany() {
            this.deleteCompany()
        },
        deleteCompany() {
            this.isLoading = true
            Company.inactivateCompany(this.Item.id)
                .then((res) => {
                    this.$toast.success(res.data.message || (this.$store.state._language == "es-ES" 
                        ? "Compañía inactivada exitosamente" 
                        : "Company deactivated successfully"))
                    this.showDeleteModal = false
                    this.$emit('companyUpdated', true)
                    this.clicked()
                })
                .catch((error) => {
                    console.error("Error deleting company:", error)
                    let errorMessage = this.$store.state._language == "es-ES" 
                        ? "Error al inactivar la compañía" 
                        : "Error deactivating company"
                    
                    if (error.response && error.response.data) {
                        if (error.response.data.message) {
                            errorMessage = error.response.data.message
                        } else if (error.response.data.error) {
                            errorMessage = error.response.data.error
                        }
                    }
                    
                    this.$toast.error(errorMessage)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        editCompany() {
            if (!this.validateForm()) {
                this.$toast.error(this.$store.state._language == "es-ES" 
                    ? "Por favor, corrija los errores del formulario" 
                    : "Please correct the form errors")
                return
            }
            
            this.isLoading = true
            this.Item.id_grupos = this.selectedGrupos.join(',')
            
            Company.updateCompany(this.Item)
                .then((res) => {
                    this.$toast.success(res.data.message || (this.$store.state._language == "es-ES" 
                        ? "Compañía actualizada exitosamente" 
                        : "Company updated successfully"))
                    this.$emit('companyUpdated', true)
                    this.clicked()
                })
                .catch((error) => {
                    console.error("Error updating company:", error)
                    let errorMessage = this.$store.state._language == "es-ES" 
                        ? "Error al actualizar la compañía" 
                        : "Error updating company"
                    
                    if (error.response && error.response.data) {
                        if (error.response.data.message) {
                            errorMessage = error.response.data.message
                        } else if (error.response.data.error) {
                            errorMessage = error.response.data.error
                        }
                    }
                    
                    this.$toast.error(errorMessage)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        clicked() {
            this.$emit('clicked', false)
        }
    },
    
    mounted() {
        Currency.getAllCurrency()
            .then((res) => {
                this.listCurrency = res.data.currency
            })
            .catch((error) => {
                console.error("Error loading currencies:", error)
            })
        
        this.loadGruposAndInit()
    }
}
</script>

<style src="../main.css"></style>